// extracted by mini-css-extract-plugin
var _1 = "ProfileGradePanel__blocks--a9uvt general__text--GXRZ9";
var _2 = "ProfileGradePanel__body--Hp1Oc general__body--iyUvL";
var _3 = "ProfileGradePanel__graph--xDje9 general__graph--iP1y3";
var _4 = "ProfileGradePanel__graphWrapper--nb4oK";
var _5 = "ProfileGradePanel__heading--rgXvZ fontSize__profileText--q79uE";
var _6 = "ProfileGradePanel__main--OaKm1 general__panel--NbC8B general__shadow--ifbUf fontSize__profileSmall--v0KsO";
var _7 = "ProfileGradePanel__text--ACwDY general__text--GXRZ9";
export { _1 as "blocks", _2 as "body", _3 as "graph", _4 as "graphWrapper", _5 as "heading", _6 as "main", _7 as "text" }
